module.exports = __webpack_public_path__ + "static/media/profile-picture-727w.7fa4e410.webp";